import dnpInterstitialViewTemplate from "./DnpInterstitialViewTemplate";

var DnpInterstitialDirective = function ($location, $window, $modal, samlTokenService, paeService) {
        return {
            restrict: 'E',
            template: dnpInterstitialViewTemplate,
            controller: ['$scope',
                function ($scope){
                    $scope.continueClick = function() {
                        $scope.$parent.$close();
                        if (!$scope.isPae){
                            var ssoWindow = window.open('', 'ssoWindow');
                            samlTokenService.navigateToken('DNP', ssoWindow, 'DNP');
                        }
                        else {
                            $window.location.href = '/participant/accounts/#/accessDeniedError/44403';
                        }
                    };
                    $scope.dismiss = function() {
                    	$scope.$parent.$close();
                    };
                }
            ],
            scope: {
                factoryname: '@',
                uniqueid: '@'
            },
            link: function($scope, element, attrs) {
                var isPaePromise = paeService.checkPaeUser();
                isPaePromise.then(function(pae) {
                    $scope.isPae = pae.partnerSSOResponse;
                }, function(reason) {
                    $scope.isPae = true;
                });
            }
        };
    };
DnpInterstitialDirective.$inject = ['$location','$window','$modal','samlTokenService', 'paeService'];
export default DnpInterstitialDirective;
